import { useEffect, useMemo } from "react";

import { useProjectActions, useProjectContext } from "@contexts/projects";

import ProjectionLoadState from "../../financialProjection/ProjectionLoadState";
import EapRuleRow from "./EapRuleRow";
import SubstepAccordion from "./SubstepAccordion";

const StepAccordion = ({ parent, months }) => {
  const {
    activeProject: { _id, steps = {} },
    filterDates,
  } = useProjectContext();
  const { loadSteps } = useProjectActions();

  useEffect(() => {
    if (_id) loadSteps(parent);
  }, [_id, parent, filterDates]);

  const cellSteps = useMemo(() => steps[parent], [steps, parent]);

  return (
    <>
      <ProjectionLoadState
        level="steps"
        parent={parent}
        isMissing={!cellSteps}
        onRetry={() => loadSteps(parent)}
      />
      {cellSteps?.map((item) => (
        <EapRuleRow
          key={item.wbs_code_id}
          item={item}
          type="step"
          typeTitle="Etapa"
          months={months}
          ChildAccordionComponent={SubstepAccordion}
        />
      ))}
    </>
  );
};

export default StepAccordion;
